import { render } from "./docFilters2.vue?vue&type=template&id=d39d6c36"
import script from "./docFilters2.vue?vue&type=script&lang=js"
export * from "./docFilters2.vue?vue&type=script&lang=js"

import "./docFilters2.vue?vue&type=style&index=0&id=d39d6c36&lang=scss"

import exportComponent from "/home/ivan/Downloads/3(1)/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__